<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card wide-modal">
      <header class="modal-card-head">
        <p class="modal-card-title">Add inbound shipment items</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label">Choose a PO item</label>
          <div class="field has-addons">
            <p class="control">
              <span class="select">
                <select v-model="locationId">
                  <option v-for="(l, i) in locations" :key="'loc-opt-'+i" :value="l.id">{{l.name}}</option>
                </select>
              </span>
            </p>
            <p class="control" v-if="locationId">
              <span class="select">
                <select v-model="poId">
                  <option v-for="(p, i) in poOpts" :key="'po-opt-'+i" :value="p.id">{{p.tranId}}</option>
                </select>
              </span>
            </p>
          </div>
        </div>
        <div v-if="error" class="notification is-danger is-light">
          <button class="delete" @click="error=''"></button>
          {{error}}
        </div>
        
        <div class="mt-6" v-if="poItems">
          <div class="field">
            <label class="label">Container</label>
            <div class="control">
              <input class="input" type="text" v-model.number="shipmentContainer">
            </div>
          </div>

          <div class="mt-6">
            <table class="table is-full-width is-hoverable">
              <thead>
                <tr>
                  <th class="num-cell">
                    <span class="is-clickable" @click="sortPoItems('line')">PO Line</span>
                    <span class="icon" v-if="poItemsSort.field == 'line'">
                      <i class="fas" :class="{'fa-sort-up': poItemsSort.asc, 'fa-sort-down': !poItemsSort.asc}"></i>
                    </span>
                  </th>
                  <th>
                    <span class="is-clickable" @click="sortPoItems('itemName')">Name</span>
                    <span class="icon" v-if="poItemsSort.field == 'itemName'">
                      <i class="fas" :class="{'fa-sort-up': poItemsSort.asc, 'fa-sort-down': !poItemsSort.asc}"></i>
                    </span>
                    <div class="field">
                      <p class="control has-icons-left">
                        <input class="input is-small" type="text" placeholder="Search" v-model="nameSearch">
                        <span class="icon is-small is-left">
                          <i class="fas fa-search"></i>
                        </span>
                      </p>
                    </div>
                  </th>
                  <th>Description</th>
                  <th class="num-cell">
                    <span class="is-clickable" @click="sortPoItems('quantity')">Quantity</span>
                    <span class="icon" v-if="poItemsSort.field == 'quantity'">
                      <i class="fas" :class="{'fa-sort-up': poItemsSort.asc, 'fa-sort-down': !poItemsSort.asc}"></i>
                    </span>
                  </th>
                  <th class="num-cell">Maximum shipment</th>
                  <th class="num-cell">Shipment quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(poItem, i) in poItems" :key="'poItems-'+i" v-if="remainingsMap[poItem.line]>0" v-show="poItem.itemName.toLowerCase().includes(nameSearch.toLowerCase())">
                  <td class="num-cell">{{poItem.line}}</td>
                  <td>{{poItem.itemName}}</td>
                  <td>{{poItem.description}}</td>
                  <td class="num-cell">{{poItem.quantity}}</td>
                  <td class="num-cell">{{remainingsMap[poItem.line]}}</td>
                  <td class="num-cell">
                    <input class="input" style="text-align: right;" type="number" min="0" :max="remainingsMap[poItem.line]" v-model.number="quantitiesMap[poItem.line]">
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th class="num-cell">{{ quantitiesTotal }}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" :class="{'is-loading': waiting}" :disabled="!isValid" @click="saveInboundItems">Save</a>
        <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'add-inbound-items-modal',
  props: ['opened', 'pos', 'inbound'],
  data () {
    return {
      error: '',
      waiting: false,
      locationId: '',
      poId: '',
      po: null,
      poMap: {},
      poItems: null,
      poItemsMap: {},
      poItemsSort: {field: 'line', asc: true},
      poItem: null,
      currentInboundItems: [],
      shipmentContainer: '',
      quantitiesMap: {},
      nameSearch: '',
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    isValid () {
      var quantities = Object.values(this.quantitiesMap)
      return this.shipmentContainer && quantities && quantities.filter(q => q > 0).length
    },
    isVendorAdmin () {
      return this.$store.state.user.groups.includes('VendorAdmin')
    },
    locations () {
      var locationMap = {}
      var poMap = {}
      for (var po of this.pos) {
        locationMap[po.locationId] = {
          id: po.locationId,
          name: po.locationName
        }
        poMap[po.id] = po
      }
      if (this.currentInboundItems.length && !this.isVendorAdmin) {
        var item = this.currentInboundItems[0]
        var po = poMap[item.poId]
        var location = locationMap[po.locationId]
        return [location]
      }
      var values = Object.values(locationMap)
      values.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      return values
    },
    poOpts () {
      var filteredPos = this.pos.filter(p => this.locationId == 'All' || this.locationId == p.locationId)
      filteredPos.sort((a, b) => {
        return b.tranId.localeCompare(a.tranId)
      })
      return filteredPos
    },
    remainingsMap () {
      var remainingsMap = {}
      this.poItems.forEach(poItem => {
        var remaining = poItem.remaining
        if (remaining > 0) {
          for (var ibi of this.currentInboundItems) {
            if (ibi.poId != this.poId) {
              continue
            }
            var ss = poItem.itemName.split(':')
            if (ibi.shipmentItemName == ss[ss.length-1].trim() && ibi.shipmentItemDescription.trim() == poItem.description.trim()) {
              remaining -= ibi.quantityExpected
            }
          }
        }
        remainingsMap[poItem.line] = remaining
      })
      return remainingsMap
    },
    quantitiesTotal () {
      var quantities = Object.values(this.quantitiesMap)
      return quantities.reduce((a, b) => a + b, 0)
    },
  },
  watch: {
    pos (val) {
      if (val) {
        var poMap = {}
        var poItemsMap = {}
        val.forEach(p => {
          poMap[p.id] = p
          poItemsMap[p.id] = []
        })
        this.poMap = poMap
        this.poItemsMap = poItemsMap
      }
    },
    poId (val) {
      if (val) {
        this.po = this.poMap[val]
        if (this.poItemsMap[val].length) {
          this.poItems = this.poItemsMap[val]
          this.makeMaps()
        } else {
          this.waiting = true
          this.$http.get(this.server + '/myapp/get-purchase-order-items-with-inbounds/' + val).then(resp => {
            var poItems = resp.body.map(i => {
              var quantity = i.quantity
              var remaining = quantity - i.quantityReceived
              if (remaining <= 0) {
                remaining = 0
              } else {
                remaining = quantity
                for (var ib of i.inbounds) {
                  if (ib.inbound.id != this.inbound.id) {
                    remaining -= ib.inboundItem.quantityExpected
                  }
                }
              }
              i.remaining = remaining
              return i
            })
            this.poItems = poItems
            this.poItemsMap[val] = poItems
            this.makeMaps()
            this.waiting = false
          }, err => {
            this.error = err.body
            this.waiting = false
          })
        }
      }
    },
    opened (val) {
      if (val) {
        if (this.locationId) {
          var locationIds = this.locations.map(l => l.id)
          if (locationIds.indexOf(this.locationId) < 0) {
            this.locationId = ''
          }
        }
        this.poItem = null
        this.currentInboundItems = this.inbound.items.slice()
      }
    },
  },
  methods: {
    close () {
      this.$emit('closeAddInboundItemsModal')
    },
    saveInboundItems () {
      if (!this.isValid) {
        return
      }
      var items = []
      for (var i=0;i<this.poItems.length;i++) {
        var poItem = this.poItems[i]
        if (this.quantitiesMap[poItem.line] > 0) {
          items.push({
            po: this.po,
            poItem: poItem,
            shipmentContainer: this.shipmentContainer,
            shipmentQuantity: this.quantitiesMap[poItem.line],
            shipmentItemClass: poItem.className,
          })
        }
      }
      this.$emit('closeAddInboundItemsModal', items)
    },
    sortPoItems (field) {
      if (this.poItemsSort.field == field) {
        this.poItemsSort.asc = !this.poItemsSort.asc
      } else {
        this.poItemsSort.field = field
        this.poItemsSort.asc = true
      }
      this.poItems.sort((a, b) => {
        var asc = this.poItemsSort.asc
        var v1 = a[field]
        var v2 = b[field]
        if (field == 'line' || field == 'quantity') {
          return asc ? v1 - v2 : v2 - v1
        }
        return asc ? v1.localeCompare(v2) : v2.localeCompare(v1)
      })
    },
    makeMaps () {
      var quantitiesMap = {}
      this.poItems.forEach(poItem => {
        quantitiesMap[poItem.line] = 0
      })
      this.quantitiesMap = quantitiesMap
    },
  },
}
</script>

<style scoped>
.wide-modal {
  width: 800px!important;
}
.num-cell {
  text-align: right !important;
}
</style>
